import { useTranslation } from 'react-i18next';
import { EMPTY_STRING } from '@constants';

import { useAppSelector } from './reduxHooks';

const useCustomTranslation = () => {
  const { translations } = useAppSelector((state) => state.translations);
  const { t } = useTranslation();

  const getTranslation = (backendKey: string, i18nKey?: string) =>
    translations[backendKey] ?? t(i18nKey ?? EMPTY_STRING);

  return { getTranslation };
};

export default useCustomTranslation;
